import { render, staticRenderFns } from "./Comments.vue?vue&type=template&id=43bd2a1b"
import script from "./Comments.ts?vue&type=script&lang=js&external"
export * from "./Comments.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports